var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.route}},[_c('i',{staticClass:"fas fa-times-circle"})])
}
var staticRenderFns = []

export { render, staticRenderFns }